export const VPS_OCI_PAGE_STEPS = {
  DETAILS: 'DETAILS',
  UPGRADE_LISTING: 'UPGRADE_LISTING',
  UPGRADE_DETAILS: 'UPGRADE_DETAILS',
};
